import "../common/elements/Header.scss";
import translate from "@/i18n/translate";
import { Link } from "react-router-dom";
import { useIntl } from "react-intl";
import { usePageTitle } from "@/hooks/usePageTitle";

export default function SiteMap(): JSX.Element {
  const intl = useIntl();
  const pageTitle = intl.formatMessage({ id: "app.pageTitle.siteMap" });
  usePageTitle(pageTitle);

  return (
    <>
      <div className="page-header">
        <div className="title-container">
          <div className="title sitemap-title">{translate("app.siteMap.title")}</div>
          <div className="title-description sitemap-desc">{translate("app.siteMap.description")}</div>
        </div>
      </div>
      <nav aria-label={intl.formatMessage({ id: "app.siteMap.navigation" })} className="sitemap-nav paper-card">
        <ul className="sitemap-links nobullets body">
          <li>
            <Link to="/insights/home" className="sitemap-link">
              {translate("app.mainnav.home")}
            </Link>
          </li>
          <li>
            <Link to="/insights/academic_office" className="sitemap-link">
              {translate("app.mainnav.academicsAndOffices")}
            </Link>
          </li>
          <li>
            <Link to="/insights/settings" className="sitemap-link">
              {translate("app.home.settings")}
            </Link>
          </li>
        </ul>
      </nav>
    </>
  );
}
